import { render, staticRenderFns } from "./Chem1LD_LFQ_Question1.vue?vue&type=template&id=84b5e180&scoped=true&"
import script from "./Chem1LD_LFQ_Question1.vue?vue&type=script&lang=js&"
export * from "./Chem1LD_LFQ_Question1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b5e180",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VImg,VSelect})
